import script from "./CreateCityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCityDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateCityDialog.vue?vue&type=style&index=0&id=bca1a1c8&lang=css"
import "./CreateCityDialog.vue?vue&type=style&index=1&id=bca1a1c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bca1a1c8"]])

export default __exports__